import { api } from '@System/api';

export default {
    getListService: params => api.get("/merchant/services", {params, loading: false}),
};
